var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"head-info"},[_vm._v(" 恭喜 "),_c('span',[_vm._v(_vm._s(_vm.name))]),_vm._v(" ，您的报名信息已提交，请谨记您的报名序号，并确保已上传本人照片。 "),_c('span',[_vm._v("报名序号："+_vm._s(_vm.serial_id))])])}
var staticRenderFns = []

export { render, staticRenderFns }